export const GOOGLE_GSI_SCRIPT_URL = 'https://accounts.google.com/gsi/client';

export const GOOGLE_ONE_TAP_SESSION_KEY = 'google_one_tap_pending';
